const state = () => ({

    allSettingsData: {},

    local: {
        mainCategory: null,
        mainSubCategories: undefined,
        secondaryCategory: null,
        locations: {},
        secondarySubCategories: undefined,
        secondaryCatSelected: undefined,
        zones: undefined,
        scopes: undefined,
        experience: null,
        mailing: 1,
        keywordsJD: null,
        allowMailing: true,
        initialized: false,
        reason: null,
        companyName: null,
        companyCode: null,
        tooManyEmails: null,
        description: null
    },

    removeData: {},

})

export default state;